/** Destino real de pago. Solo el botón del bloque de cierre apunta aquí. */
export const CHECKOUT_URL = 'https://rutinasimple.com//cart/53099547132185:1'

/** Ancla del bloque de cierre: el resto de los CTA llevan a ese botón. */
export const CHECKOUT_ANCHOR = '#checkout'

/** Variante de Shopify incluida en la URL del carrito. */
export const CHECKOUT_VARIANT_ID = '53099547132185'

/** Datos del producto enviados con el evento AddToCart. */
export const ADD_TO_CART_PAYLOAD = {
  content_name: 'Bundle Conexión Real — 5 Ebooks',
  content_type: 'product',
  content_ids: [CHECKOUT_VARIANT_ID],
  contents: [{ id: CHECKOUT_VARIANT_ID, quantity: 1 }],
  value: 9.99,
  currency: 'USD'
}
